import './GlobalHeader.css';
import './GlobalButton.css';
import React, { useState, useEffect, useRef } from 'react';

const GlobalHeader = () => {
  const [isScrolling, setIsScrolling] = useState(false);
  
  const prevTopRef = useRef(0);
  const headerRef = useRef(null);

  useEffect(() => {
    prevTopRef.current = window.scrollY;

    const handleScroll = () => {
      const currentTop = window.scrollY;
      const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 0;

      if (currentTop > prevTopRef.current && currentTop > headerHeight) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }

      prevTopRef.current = currentTop;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header 
      ref={headerRef} 
      className={`global-header ${isScrolling ? 'js-global-header-scrolling' : ''}`}
    >
      <div className="info-bar">
        <span>CREAZIONI ORIGINALI</span>
        <span className="pre-punto">RECUPERO CREATIVO</span>
        <span className="pre-punto">FATTO A MANO IN ITALIA</span>
      </div>
      <nav>
        <ul>
          <li><a href='#collezione'>Collezione</a></li>
          <li><a href='#atelier'>L'atelier</a></li>
          <li><a href='#comeNasce'>Come nasce</a></li>
          <li><a href='#contatti'>Contatti</a></li>
        </ul>
        <button className="button button--janus" style={{"left":"20px"}}><span>Richiedi un pezzo</span></button>
      </nav>

    </header>
  );
};

export default GlobalHeader;
